import {memo} from "react";
import {Link} from "react-router-dom";
import {numberFormat} from "~/utils";
import FontAwesomeIcon from "~/components/FontAwesome";
import DashboardWidgetHeader from "./DashboardWidgetHeader";

/**
 * Dòng tiền & số dư tài khoản cho Dashboard Kế toán trưởng.
 * Dữ liệu: dashboardApi.accountingCashFlow() = { accounts[], total{opening,totalIn,totalOut,closing} }.
 */
const typeColor = {
	cash:   '#16a34a',
	wallet: '#db2777',
	pos:    '#0284c7',
	bank:   '#4f46e5',
};

const typeIcon = {
	cash:   'fa-light fa-money-bill-wave',
	wallet: 'fa-light fa-wallet',
	pos:    'fa-light fa-credit-card',
	bank:   'fa-light fa-building-columns',
};

function AccountingCashFlowWidget({data, loading = false}) {

	const accounts = data?.accounts || [];
	const total    = data?.total || {opening: 0, totalIn: 0, totalOut: 0, closing: 0};

	const link = (
		<Link to="/report/cash-flow" style={{color: '#fff', fontSize: 12, display: 'inline-flex', alignItems: 'center', gap: 4}}>
			Chi tiết <FontAwesomeIcon icon="fa-light fa-arrow-up-right-from-square" />
		</Link>
	);

	const stat = (label, value, color) => (
		<div style={{flex: 1, textAlign: 'center', padding: '4px 6px'}}>
			<p style={{fontSize: 11, color: '#64748b', margin: 0}}>{label}</p>
			<p style={{fontSize: 15, fontWeight: 700, color, margin: '2px 0 0'}}>{numberFormat(value)}</p>
		</div>
	);

	return (
		<div style={{borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 12px rgba(79,70,229,0.12)', background: '#fff'}}>
			<DashboardWidgetHeader
				icon="fa-light fa-money-bill-transfer"
				title="Dòng tiền & số dư"
				gradient="linear-gradient(135deg, #3730a3 0%, #4f46e5 60%, #818cf8 100%)"
				extra={link}
			/>
			<div style={{padding: '14px 18px'}}>
				{loading
					? <div style={{textAlign: 'center', color: '#94a3b8', fontSize: 13, padding: '12px 0'}}>Đang tải...</div>
					: (
						<>
							<div style={{display: 'flex', alignItems: 'stretch', gap: 4, marginBottom: 14}}>
								{stat('Đầu kỳ', total.opening, '#475569')}
								<div style={{width: 1, background: '#e2e8f0'}} />
								{stat('Thu', total.totalIn, '#16a34a')}
								<div style={{width: 1, background: '#e2e8f0'}} />
								{stat('Chi', total.totalOut, '#e11d48')}
							</div>

							<div style={{
								display: 'flex', justifyContent: 'space-between', alignItems: 'center',
								background: '#f8fafc', borderRadius: 10, padding: '8px 12px', marginBottom: 12,
							}}>
								<span style={{fontSize: 12, color: '#64748b'}}>Tổng số dư cuối kỳ</span>
								<b style={{fontSize: 17, color: total.closing < 0 ? '#ef4444' : '#0284c7'}}>{numberFormat(total.closing)}</b>
							</div>

							<div style={{borderTop: '1px dashed #e2e8f0', paddingTop: 8}}>
								{accounts.length === 0 && (
									<p style={{fontSize: 12, color: '#94a3b8', textAlign: 'center', margin: '8px 0'}}>Không có tài khoản</p>
								)}
								{accounts.map((acc) => (
									<div key={`cf-${acc.key}`} style={{
										display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px 0',
									}}>
										<span style={{display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: '#475569', minWidth: 0}}>
											<FontAwesomeIcon icon={typeIcon[acc.type] || 'fa-light fa-circle-small'} style={{color: typeColor[acc.type] || '#94a3b8'}} />
											<span style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{acc.title}</span>
										</span>
										<b style={{fontSize: 13, color: acc.closing < 0 ? '#ef4444' : '#334155', flexShrink: 0, marginLeft: 8}}>{numberFormat(acc.closing)}</b>
									</div>
								))}
							</div>
						</>
					)
				}
			</div>
		</div>
	);
}

export default memo(AccountingCashFlowWidget);
